import React from 'react';
import { useAPIContext } from '../../context/api';
import { BrandsAPI } from '../../../../constructs/brands/interface';

export const useSendChatMessage = (bannerId: string) => {
  const { callEndpoint } = useAPIContext();
  const [isSending, setIsSending] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const sendMessage = React.useCallback(
    async (prompt: string) => {
      if (!prompt || !bannerId) return null;

      try {
        setIsSending(true);
        setError(null);

        const response = await callEndpoint<BrandsAPI, 'send-chat-message'>(
          'brands',
          `/banners/${bannerId}/messages`,
          'POST',
          { prompt }
        );

        return response;
      } catch (err) {
        console.error('Error sending chat message:', err);
        setError('Error al enviar mensaje');
        return null;
      } finally {
        setIsSending(false);
      }
    },
    [bannerId, callEndpoint]
  );

  return {
    sendMessage,
    isSending,
    error
  };
};
